/**
 *
 * ResourceItemSelector
 *
 */

import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import ResourceItem from 'components/ResourceItem';
import PeopleItem from 'containers/People/PeopleItem';
import { getFormattedType } from './utils';

class ResourceItemSelector extends React.PureComponent {
  render() {
    const { item, recommendation } = this.props;
    if (_isEmpty(item)) return false;
    const { type } = item;

    const formattedType = getFormattedType(type);

    switch (type) {
      case 'Videos':
      case 'video':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/videos"
            recommendation={recommendation}
          />
        );
      case 'Apps':
      case 'application':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/apps"
            recommendation={recommendation}
          />
        );
      case 'Podcasts':
      case 'podcast':
      case 'Episode':
      case 'episode':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/podcasts"
            recommendation={recommendation}
          />
        );
      case 'People':
      case 'person':
        return (
          <PeopleItem
            item={item}
            key={item.slug}
            recommendation={recommendation}
          />
        );
      case 'Books':
      case 'book':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/books"
            recommendation={recommendation}
          />
        );
      case 'Articles':
      case 'activity':
      case 'News':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/articles"
            recommendation={recommendation}
          />
        );
      case 'FAQ':
        return (
          <ResourceItem
            item={item}
            type="faq"
            recommendation={recommendation}
          />
        );
      case 'Organizations':
      case 'organization':
        return (
          <ResourceItem
            item={item}
            type={formattedType}
            route="/organizations"
            recommendation={recommendation}
          />
        );
      case 'Online Programs':
        return (
          <ResourceItem
            item={item}
            type="program"
            route="/programs"
            recommendation={recommendation}
          />
        );
      default:
        return null;
    }
  }
}

ResourceItemSelector.propTypes = {
  item: PropTypes.object,
  recommendation: PropTypes.bool,
};

ResourceItemSelector.defaultProps = {
  recommendation: false,
};

export default ResourceItemSelector;
